import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  size?: number;
  message?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 40,
  message = 'Cargando...'
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 fade-in">
      {/* Spinner minimalista */}
      <Loader2
        size={size}
        className="animate-spin text-primary dark:text-primary-dark"
      />

      {/* Mensaje simple */}
      {message && (
        <p className="mt-4 text-sm font-medium text-neutral-600 dark:text-neutral-400">
          {message}
        </p>
      )}
    </div>
  );
};

export default LoadingSpinner;
